/**
 * Created by chenzheyu on 2017/7/4.
 */

import XkCapitalRecord from './src/capitalRecordList.vue'

XkCapitalRecord.install = function (Vue) {
  Vue.component(XkCapitalRecord.name, XkCapitalRecord)
}

export default XkCapitalRecord



// WEBPACK FOOTER //
// ./src/components/module/capitalRecordList/index.js